<template>
  <van-radio-group v-model="selected" :direction="direction" @change="onChange">
    <van-radio :name="!getLabel ? lst.dictValue : lst.dictLabel" v-for="lst in list" :key="lst.dictCode">{{ lst.dictLabel }}</van-radio>
  </van-radio-group>
</template>

<script>
export default {
    props: {
      direction: {
        type: String,
        default: () => 'horizontal'
      },
      // 类型编码
      typeCode: {
        type: String,
        required: true
      },
      // 默认值
      value: String,
      getLabel: {
        type: Boolean,
        default() {
          return false
        }
      }
    },
    data () {
      return {
        list: [],
        selected: this.value
      }
    },
    mounted() {
      this.getList()
    },
    watch: {
      value() {
        this.selected = this.value
      }
    },
    methods: {
      // 查询字典列表
      getList() {
        // 不刷新的情况下只请求一次
        if (!window._dictionary) {
          window._dictionary = {}
        }
        if (window._dictionary[this.typeCode]) {
          this.list = window._dictionary[this.typeCode]
        } else {
          this.$baseApi.getDictData({
            dictType: this.typeCode
          }).then(res => {
            if (res.success) {
              this.list = window._dictionary[this.typeCode] = res.data.list.filter(item => item.status).sort((a, b) => a.id - b.id)
            }
          })
        }
      },
      onChange(dicCode) {
        this.$emit('input', dicCode)
      }
    }
}
</script>